import React from 'react';
import PropTypes from 'prop-types';
import SweetAlert from 'sweetalert-react';
import { compose, withHandlers } from 'recompose';

import withToggle from '../../hoc/WithToggle';

const BrokenReserveAndPayButton = (props) => {
  const {
    on,
    off,
    toggled,
    disabled,
    confirmAndClose,
  } = props;

  return (
    <button
      onClick={on}
      className="c-btn c-btn--primary u-1/1 u-mb-"
      disabled={disabled}
    >
      Reserve & Pay
      <SweetAlert
        show={toggled}
        title="Error"
        text="Please use RESERVE button."
        type="error"
        confirmButtonColor="#009d92"
        confirmButtonText="Reserve"
        onEscapeKey={off}
        onConfirm={confirmAndClose}
        onCancel={off}
        showCancelButton
        cancelButtonText="Close"
      />
    </button>
  );
};

BrokenReserveAndPayButton.propTypes = {
  on: PropTypes.func.isRequired,
  off: PropTypes.func.isRequired,
  toggled: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  confirmAndClose: PropTypes.func.isRequired,
};

export default compose(
  withToggle,
  withHandlers({
    confirmAndClose: props => () => {
      props.off();
      props.onConfirm();
    },
  })
)(BrokenReserveAndPayButton);



// WEBPACK FOOTER //
// ./src/app/reservation/components/BrokenReserveAndPayButton.jsx